import { ShieldPlus, SlashCircle01 } from "@untitledui/icons";
import { TextArea } from "@/components/base/textarea/textarea";
import type { CustomRiskEditRequestForm } from "./RequestCustomRiskEditModal";

const STOP_FLAGGING_PLACEHOLDER = `e.g. Posts mentioning "low calorie" recipes are getting flagged even when the calorie count is correct.

1. https://
2. https://
3. https://`;

type Props = {
  riskName: string;
  form: CustomRiskEditRequestForm;
  onChange: (patch: Partial<CustomRiskEditRequestForm>) => void;
  errors: Record<string, string>;
};

export function StopFlaggingStep({ riskName, form, onChange, errors }: Props) {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex gap-8">
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="flex items-center gap-1.5">
            <ShieldPlus className="size-5 shrink-0 text-quaternary" />
            <p className="text-sm font-medium text-secondary">Risk to edit</p>
          </div>
          <p className="text-xs text-quaternary">This is the risk you would like changes to</p>
        </div>
        <div className="w-[395px] shrink-0">
          <div className="flex h-11 items-center rounded-lg border border-disabled bg-disabled_subtle px-3.5 text-md text-disabled">
            {riskName}
          </div>
        </div>
      </div>

      <div className="flex gap-8">
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="flex items-start gap-1.5">
            <SlashCircle01 className="size-5 shrink-0 text-quaternary" />
            <p className="text-sm font-medium text-secondary">What should we stop flagging?</p>
          </div>
          <ul className="list-disc pl-5 text-xs text-quaternary">
            <li>Describe what's being flagged that shouldn't be.</li>
            <li>Add links to example videos that are wrongly flagged today.</li>
            <li>Aim for 3–5 example links if you can.</li>
          </ul>
        </div>
        <div className="w-[395px] shrink-0">
          <TextArea
            aria-label="What should we stop flagging?"
            isRequired
            placeholder={STOP_FLAGGING_PLACEHOLDER}
            value={form.stopFlagging}
            onChange={(v) => onChange({ stopFlagging: v })}
            isInvalid={!!errors.stopFlagging}
            rows={10}
          />
          {errors.stopFlagging && <p className="mt-1.5 text-sm text-error-primary">{errors.stopFlagging}</p>}
        </div>
      </div>
    </div>
  );
}
